import React, { useEffect, useState } from 'react';
import NavBar from '../component/NavBar'
import Preventivo from '../component/Preventivo'
import { WizardAppartamentoVilla } from '../component/WizardAppartamentoVilla';
import { Button } from 'primereact/button';
import { useHistory , useLocation} from "react-router-dom";
import SendPreventivo from "../component/SendPreventivo"


const PreventivoPage = (props) => {

  
    const history = useHistory();
    const location = useLocation();
 
    const [preventivoOrig, setPreventivoOrig] = useState()
    const [visiblePreventivo, setVisiblePreventivo] = useState(false)
    const [visibleSend, setVisibleSend] = useState(false)

    const [preventivo, setPreventivo] = useState()
    const [prevTab, setPrevTab] = useState([])
    const [extraTab, setExtraTab] = useState([])

    useEffect(() => {
        if (location.state?.preventivo)
            setPreventivoOrig(location.state.preventivo)
        else if (props.preventivo)
            setPreventivoOrig(props.preventivo)

    }, [location, props])

    const handleEditPreventivo = () => {
        if (!location.state.editURL)
            setVisiblePreventivo(true)
        else
            history.push(location.state.editURL, { preventivo: preventivoOrig })
    }

    const handleSavePreventivo = () => {
        /*
         dialog con richiesta nome, mail ecc, 
        */
        setVisibleSend(true)
    }

    const commandTemplate = () => {
        return (
            <div className='flex gap-3'>
                <div className=''>
                    <Button onClick={handleSavePreventivo} label='Invia preventivo' icon="pi pi-send" type='button' />
                </div>
                <div className=''>
                    <Button onClick={handleEditPreventivo} label='Modifica preventivo' icon="pi pi-pencil" type='button' />
                </div>
            </div>
        )
    }

    const handleResults = (_preventivo, _prevTab, _extraTab) => {
        setPreventivo(_preventivo)
        setPrevTab(_prevTab)
        setExtraTab(_extraTab)
    }

    return (
        <div >
            <NavBar  home={true}/>
            <div className="surface-section text-800 p-4">
                <Preventivo preventivo={preventivoOrig} commandTemplate={commandTemplate()} onCalculate={handleResults}/>
                {visiblePreventivo && <WizardAppartamentoVilla preventivo={preventivoOrig} onExit={() => setVisiblePreventivo(false)} />}
                {visibleSend && <SendPreventivo setVisible={setVisibleSend} extraTab={extraTab} prevTab={prevTab} preventivo={preventivo} />}
            </div>
        </div>
    )
}
export default PreventivoPage